module.exports = __webpack_public_path__ + "img/Invite_Mobile.jpg";